import React, { Component } from 'react';
import './MouseBlocker.css';
import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class MouseBlocker extends Component {
	constructor(props){
		super(props)
		const{spinnerHandles}=props;
		this._spinnerHandles = spinnerHandles;
		this._spinnerHandlesChanged = this._spinnerHandlesChanged.bind(this);
		spinnerHandles.addEventListener('change', this._spinnerHandlesChanged);
		this._handleClick= this._handleClick.bind(this);
		this.state={visible:false};
	}
	_spinnerHandlesChanged(e){
		this.setState({visible:e.hasHandles});
	}
	_handleClick(e){
		if(!e)e=window.event;
		e.stopPropagation&&e.stopPropagation();
		e.preventDefault&&e.preventDefault();
	}
	render() {
		let className ="mouse-blocker";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} onClick={this._handleClick}>
				</div>);
	}
}
